import React from "react";
import { useRoutes } from "react-router-dom";

// import { store } from "@/store/configureStore";
import { RouterAuth } from "./routes";
import { filterRoutesByRole } from "./filtered_routes";
import { routes } from "@/router/routes";

const RootRouter = () => {
  // 每次用户角色改变时就重新获取路由以更新菜单
  // const { currentRole } = store.getState().user;
  const curRoutes = React.useMemo(() => {
    return filterRoutesByRole(routes);
  }, []);

  // useRoutes必须在BrowserRouter组件包含的子组件中使用，它存在于BrowserRouter中
  const Element = useRoutes(curRoutes);

  return <RouterAuth>{Element}</RouterAuth>;
};

export default RootRouter;
